type Listener = (seconds: number | null) => void;

let remainingSeconds: number | null = null;
const listeners = new Set<Listener>();

export function setRemainingSeconds(sec: number | null) {
  remainingSeconds = sec;
  for (const l of listeners) l(remainingSeconds);
}

export function getRemainingSeconds() {
  return remainingSeconds;
}

export function subscribe(fn: Listener) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
